export const ACTION_NAMES = {
  UPDATE_STATE_WEBSITE_DATA: 'UPDATE_STATE_WEBSITE_DATA',
};
export const updateWebsiteData = (data) => ({
  type: ACTION_NAMES.UPDATE_STATE_WEBSITE_DATA,
  payload: data,
});
